/* SB · Bland selv v2 — tiered mix-and-match builder (vanilla JS, talks to the Shopify AJAX Cart API).
   The page only previews the tier math; the Shopify automatic discount is the source of truth in the cart. */
(function () {
  'use strict';

  var root = document.querySelector('[data-bsv]');
  if (!root) return;

  function readJson(sel) {
    try { return JSON.parse(root.querySelector(sel).textContent); } catch (e) { console.error('[bsv] bad json', sel, e); return null; }
  }
  var PRODUCTS = readJson('[data-bsv-products]') || [];
  var FAMILIES = readJson('[data-bsv-families]') || [];
  var SETS = readJson('[data-bsv-sets]') || [];
  var CFG = readJson('[data-bsv-config]') || { tiers: [[3, 30], [4, 35], [5, 40]], messages: {}, cats: [] };
  var M = CFG.messages || {};
  var TIERS = CFG.tiers; // [[minCount, pct], ...] ascending
  var MAX_COUNT = TIERS[TIERS.length - 1][0];
  var MIN_COUNT = TIERS[0][0];
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var STRIP = (CFG.stripPrefix || '').split(',').filter(Boolean);

  var BY = {};
  PRODUCTS.forEach(function (p) { BY[p.id] = p; });
  if (CFG.hideSoldOut) {
    FAMILIES = FAMILIES.map(function (f) { var vs = f.variants.filter(function (v) { return BY[v.id] && BY[v.id].available; }); return Object.assign({}, f, { variants: vs, def: vs.some(function (v) { return v.id === f.def; }) ? f.def : (vs[0] && vs[0].id) }); });
  }
  FAMILIES = FAMILIES.filter(function (f) { return f.variants.length && f.variants.every(function (v) { return BY[v.id]; }); });
  /* Size chip label when the block left it blank: "Ø28", "32×26,5", else the name without the strip prefixes. */
  function shortLabel(name) {
    var m = /Ø\s?(\d+(?:,\d+)?)/.exec(name); if (m) return 'Ø' + m[1];
    m = /(\d+(?:,\d+)?)\s?[×x]\s?(\d+(?:,\d+)?)/.exec(name); if (m) return m[1] + '×' + m[2];
    return shortName(name);
  }
  FAMILIES = FAMILIES.map(function (f) { return Object.assign({}, f, { variants: f.variants.map(function (v) { return v.short ? v : Object.assign({}, v, { short: shortLabel(BY[v.id].name) }); }) }); });
  /* Bestsellers row: editor-picked variant ids, only those the builder knows (in the collection / a family). */
  var BEST = {};
  var POP_FAMS = (readJson('[data-bsv-popular]') || []).filter(function (id, i, a) {
    return BY[id] && a.indexOf(id) === i && (!CFG.hideSoldOut || BY[id].available);
  }).map(function (id) {
    BEST[id] = true;
    var home = FAMILIES.find(function (f) { return f.variants.some(function (v) { return v.id === id; }); });
    return { fid: 'pop-' + id, cat: home ? home.cat : 'pander', def: id, single: '', variants: [{ id: id, short: shortLabel(BY[id].name) }] };
  });
  SETS = SETS.filter(function (s) { return s.ids.length && s.ids.every(function (id) { return BY[id] && (!CFG.hideSoldOut || BY[id].available); }); });

  /* ---------- helpers ---------- */
  function r2(n) { return Math.round(n * 100) / 100; }
  function fmt(n) {
    var v = r2(n), w = Math.floor(v), f = Math.round((v - w) * 100);
    var s = String(w).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return (f ? s + ',' + String(f).padStart(2, '0') : s) + ' kr';
  }
  function pctFor(c) { var p = 0; TIERS.forEach(function (t) { if (c >= t[0]) p = t[1]; }); return p; }
  function nextMsg(c) {
    if (c >= 5) return M.m5; if (c === 4) return M.m4; if (c === 3) return M.m3; if (c === 2) return M.m2; if (c === 1) return M.m1; return M.m0;
  }
  function toastFor(pct) { var i = TIERS.findIndex(function (t) { return t[1] === pct; }); return [M.toast1, M.toast2, M.toast3][i] || ''; }
  function shortName(name) { STRIP.forEach(function (s) { if (name.indexOf(s) === 0) name = name.slice(s.length); }); return name; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function stars(r) { var n = Math.round((r || 0) * 2) / 2, out = ''; for (var i = 1; i <= 5; i++) out += i <= n ? '★' : (i - .5 === n ? '★' : '☆'); return out; }
  function count(q) { return Object.keys(q).reduce(function (n, id) { return n + q[id]; }, 0); }
  function setQty(ids) { var q = {}; ids.forEach(function (id) { q[id] = (q[id] || 0) + 1; }); return q; }
  function qs(sel, ctx) { return (ctx || root).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }

  /* ---------- ticking numbers ---------- */
  var lastTick = {};
  var tickTimers = {};
  function tick(el, key, value) {
    if (!el) return;
    var from = lastTick[key];
    lastTick[key] = value;
    if (from == null || from === value || REDUCED) { el.textContent = fmt(value); el.classList.remove('is-hot'); return; }
    cancelAnimationFrame(tickTimers[key]);
    var t0 = performance.now(), d = 600;
    el.classList.add('is-hot');
    (function frame(now) {
      var k = Math.min(1, (now - t0) / d), e = 1 - Math.pow(1 - k, 3);
      el.textContent = fmt(from + (value - from) * e);
      if (k < 1) tickTimers[key] = requestAnimationFrame(frame);
      else { el.textContent = fmt(value); el.classList.remove('is-hot'); }
    })(t0);
  }

  /* ---------- state ---------- */
  var state = { qty: {}, sel: {}, filter: 'alle', sort: 'standard', open: false, busy: false };
  var toastTimer = null;

  function selFor(qty, prev) {
    var sel = Object.assign({}, prev || {});
    FAMILIES.forEach(function (f) {
      var hit = f.variants.find(function (v) { return qty[v.id]; });
      sel[f.fid] = hit ? hit.id : (sel[f.fid] || f.def || f.variants[0].id);
    });
    POP_FAMS.forEach(function (f) { sel[f.fid] = f.def; });
    return sel;
  }

  function applyQty(q) {
    var before = pctFor(count(state.qty)), after = pctFor(count(q));
    state.qty = q;
    if (after > before) showToast(toastFor(after));
    renderAll();
    track('bsv_pack_change', { count: count(q), pct: after });
  }
  function change(id, d) {
    var q = Object.assign({}, state.qty); var n = (q[id] || 0) + d;
    if (n <= 0) delete q[id]; else q[id] = n;
    applyQty(q);
  }
  function remove(id) { var q = Object.assign({}, state.qty); delete q[id]; applyQty(q); }
  function loadSet(set) {
    var q = setQty(set.ids);
    state.sel = selFor(q, state.sel);
    closeSheet();
    applyQty(q);
    track('bsv_load_set', { name: set.name });
  }

  function summary(qty) {
    var ids = Object.keys(qty).map(Number); var c = count(qty); var pct = pctFor(c);
    var lines = ids.map(function (id) { var p = BY[id]; var unit = r2(p.price * (1 - pct / 100)); return { id: id, p: p, qty: qty[id], unit: unit }; });
    var normal = lines.reduce(function (n, l) { return n + l.p.price * l.qty; }, 0);
    var total = lines.reduce(function (n, l) { return n + l.unit * l.qty; }, 0);
    return { count: c, pct: pct, lines: lines, normal: normal, total: total, saving: r2(normal - total), ok: c >= MIN_COUNT, rail: Math.min(100, c / MAX_COUNT * 100) };
  }

  /* ---------- toast ---------- */
  function showToast(text) {
    if (!text) return;
    var host = qs('[data-bsv-toast-host]'), desk = qs('[data-bsv-toast-desk]');
    host.innerHTML = '<div class="bsv-toast" role="status">' + esc(text) + '</div>';
    desk.innerHTML = '<div class="bsv-toast bsv-toast--sm" role="status">' + esc(text) + '</div>';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { host.innerHTML = ''; desk.innerHTML = ''; }, 2200);
  }

  /* ---------- rendering: tiers, chips, quick sets ---------- */
  function renderTiers(pct) {
    var c = count(state.qty);
    var active = 0; TIERS.forEach(function (t, i) { if (pct === t[1]) active = i; });
    qsa('[data-bsv-tiers]').forEach(function (box) {
      qsa('.bsv-tier', box).forEach(function (el, i) {
        el.classList.toggle('is-active', i === active);
        el.classList.toggle('is-reached', c >= TIERS[i][0]);
      });
    });
  }
  function setIsChosen(set) {
    var q = setQty(set.ids); var keys = Object.keys(state.qty);
    if (keys.length !== Object.keys(q).length) return false;
    return keys.every(function (id) { return q[id] === state.qty[id]; });
  }
  function renderChips() {
    var box = qs('[data-bsv-chips]'); if (!box) return;
    var used = {}; FAMILIES.forEach(function (f) { used[f.cat] = true; });
    box.innerHTML = CFG.cats.filter(function (c) { return c[0] === 'alle' || used[c[0]]; }).map(function (c) {
      return '<button type="button" class="bsv-chip' + (state.filter === c[0] ? ' is-active' : '') + '" data-filter="' + c[0] + '" aria-pressed="' + (state.filter === c[0]) + '">' + esc(c[1]) + '</button>';
    }).join('');
  }
  function setCard(set) {
    var pct = pctFor(set.ids.length);
    var normal = set.ids.reduce(function (n, id) { return n + BY[id].price; }, 0);
    var total = set.ids.reduce(function (n, id) { return n + r2(BY[id].price * (1 - pct / 100)); }, 0);
    return { pct: pct, normal: normal, total: total, meta: set.ids.length + ' ' + (M.items || 'varer') + ', ' + pct + ' %' };
  }
  function renderQuick() {
    var box = qs('[data-bsv-quick]'); if (!box) return;
    box.innerHTML = SETS.map(function (s, i) {
      var c = setCard(s);
      var thumbs = s.ids.slice(0, 5).map(function (id) { return '<span class="bsv-chip-set__thumb"><img src="' + esc(BY[id].img) + '" alt="" loading="lazy" width="26" height="26"></span>'; }).join('');
      var on = setIsChosen(s);
      return '<button type="button" class="bsv-chip-set' + (on ? ' is-chosen' : '') + '" data-set="' + i + '" aria-pressed="' + on + '"><span class="bsv-chip-set__thumbs">' + thumbs + '</span><span class="bsv-chip-set__text"><span class="bsv-chip-set__name">' + esc(s.name) + '</span> <span class="bsv-chip-set__meta"><span class="bsv-chip-set__dot">· </span>' + esc(c.meta) + '<span class="bsv-chip-set__price"> · ' + fmt(c.total) + '</span></span></span></button>';
    }).join('');
  }
  function renderSets() {
    var box = qs('[data-bsv-setgrid]'); if (!box) return;
    box.innerHTML = SETS.map(function (s, i) {
      var c = setCard(s);
      var thumbs = s.ids.map(function (id) { return '<div class="bsv-set__thumb"><img src="' + esc(BY[id].img) + '" alt="" loading="lazy" width="60" height="60"></div>'; }).join('');
      var items = s.ids.map(function (id) { return shortName(BY[id].name); }).join(' + ');
      return '<article class="bsv-set' + (setIsChosen(s) ? ' is-chosen' : '') + '"><div class="bsv-set__head"><h3 class="bsv-set__name">' + esc(s.name) + '</h3><span class="bsv-set__meta">' + esc(c.meta) + '</span></div>' +
        '<div class="bsv-set__thumbs">' + thumbs + '</div><p class="bsv-set__items">' + esc(items) + '</p>' +
        '<div class="bsv-set__price"><s>' + fmt(c.normal) + '</s><strong>' + fmt(c.total) + '</strong></div>' +
        '<button type="button" class="bsv-btn bsv-btn--secondary bsv-set__btn' + (setIsChosen(s) ? ' is-chosen' : '') + '" data-set="' + i + '" aria-pressed="' + setIsChosen(s) + '">' + (setIsChosen(s) ? '✓ Valgt – tilpas frit' : 'Brug som udgangspunkt') + '</button></article>';
    }).join('');
  }

  /* ---------- rendering: product grid ---------- */
  function visibleFamilies() {
    var fams = FAMILIES.filter(function (f) { return state.filter === 'alle' || f.cat === state.filter; });
    var priceOf = function (f) { return BY[state.sel[f.fid]].price; };
    /* Standard order = category order (as the filter chips), then block/collection order — so auto cards land in their group. */
    var catRank = {}; (CFG.cats || []).forEach(function (c, i) { catRank[c[0]] = i; });
    fams = fams.map(function (f, i) { return [f, i]; }).sort(function (a, b) { return ((catRank[a[0].cat] || 0) - (catRank[b[0].cat] || 0)) || (a[1] - b[1]); }).map(function (x) { return x[0]; });
    if (state.sort === 'asc') fams = fams.slice().sort(function (a, b) { return priceOf(a) - priceOf(b); });
    if (state.sort === 'desc') fams = fams.slice().sort(function (a, b) { return priceOf(b) - priceOf(a); });
    return fams;
  }
  function cardHtml(f, shownPct) {
    var vid = state.sel[f.fid]; var p = BY[vid]; var q = state.qty[vid] || 0;
    var famQty = f.variants.reduce(function (n, v) { return n + (state.qty[v.id] || 0); }, 0);
    var inSizes = f.variants.filter(function (v) { return state.qty[v.id]; }).map(function (v) { return v.short; });
    var badge = f.variants.length > 1 ? (M.inPack + ' · ' + inSizes.join(', ')) : (famQty > 1 ? M.inPack + ' ×' + famQty : M.inPack);
    var showSizeRow = f.variants.length > 1 || CFG.showSizes;
    var sizes = f.variants.length > 1
      ? f.variants.map(function (v) { return '<button type="button" class="bsv-size' + (v.id === vid ? ' is-selected' : '') + (state.qty[v.id] ? ' has-qty' : '') + '" data-size="' + v.id + '" data-fid="' + esc(f.fid) + '" aria-pressed="' + (v.id === vid) + '">' + esc(v.short) + '</button>'; }).join('')
      : '<div class="bsv-size--single">' + esc(f.single || f.variants[0].short || '') + '</div>';
    var reviews = p.reviews > 0
      ? '<span class="bsv-stars" aria-hidden="true">' + stars(p.rating) + '</span>' + (p.rating > 0 ? '<b>' + String(Math.round(p.rating * 10) / 10).replace('.', ',') + '</b> · ' : '') + p.reviews + ' <span class="bsv-card__revword">' + esc(M.reviews || '') + '</span>'
      : esc(M.newItem || '');
    var action = !p.available
      ? '<div class="bsv-stepper" style="border-color:var(--bsv-line)"><span class="bsv-stepper__qty" style="grid-column:1/-1;color:var(--bsv-ink-faint)">' + esc(M.soldOut) + '</span></div>'
      : q > 0
        ? '<div class="bsv-stepper"><button type="button" data-dec="' + vid + '" aria-label="Fjern en">−</button><span class="bsv-stepper__qty">' + q + '</span><button type="button" data-inc="' + vid + '" aria-label="Tilføj en">+</button></div>'
        : '<button type="button" class="bsv-btn bsv-btn--primary bsv-card__add" data-inc="' + vid + '">' + esc(M.add) + '</button>';
    var isBest = BEST[vid] && M.best;
    var badges = (isBest ? '<span class="bsv-card__badge bsv-card__badge--best">' + esc(M.best) + '</span>' : '') +
      (famQty > 0 ? '<span class="bsv-card__badge">' + esc(badge) + '</span>' : '');
    return '<article class="bsv-card' + (famQty > 0 ? ' in-pack' : '') + (isBest ? ' is-best' : '') + (showSizeRow ? '' : ' bsv-card--nosize') + '" data-card="' + esc(f.fid) + '">' +
      '<a class="bsv-card__img" href="' + esc(p.url) + '" data-qv="' + vid + '" aria-label="' + esc(p.name) + '"><img src="' + esc(p.img) + '" alt="' + esc(p.name) + '" loading="lazy" width="300" height="300"><span class="bsv-card__zoom" aria-hidden="true">+</span></a>' +
      (badges ? '<div class="bsv-card__badges">' + badges + '</div>' : '') +
      (showSizeRow ? '<div class="bsv-card__sizes">' + sizes + '</div>' : '') +
      '<div class="bsv-card__name"><a href="' + esc(p.url) + '" data-qv="' + vid + '">' + esc(shortName(p.name)) + '</a></div>' +
      '<div class="bsv-card__reviews">' + reviews + '</div>' +
      '<div class="bsv-card__price"><span class="bsv-tick" data-tick="c' + vid + '"></span><s>' + fmt(p.price) + '</s><span class="bsv-card__note bsv-card__note--inline">' + esc(M.at) + ' ' + shownPct + ' %</span></div>' +
      '<div class="bsv-card__note bsv-card__note-row">' + esc(M.at) + ' ' + shownPct + ' %</div>' +
      action + '</article>';
  }
  function renderGrid() {
    var box = qs('[data-bsv-grid]'); if (!box) return;
    var pct = pctFor(count(state.qty)); var shown = pct || TIERS[0][1];
    box.innerHTML = visibleFamilies().map(function (f) { return cardHtml(f, shown); }).join('');
    visibleFamilies().forEach(function (f) {
      var vid = state.sel[f.fid]; var p = BY[vid];
      tick(qs('[data-tick="c' + vid + '"]', box), 'c' + vid, r2(p.price * (1 - shown / 100)));
    });
  }

  function renderPop() {
    var box = qs('[data-bsv-pop]'); if (!box) return;
    var section = box.closest('[data-bsv-pop-section]');
    if (section) section.hidden = !POP_FAMS.length;
    var pct = pctFor(count(state.qty)); var shown = pct || TIERS[0][1];
    box.innerHTML = POP_FAMS.map(function (f) { return cardHtml(f, shown); }).join('');
    POP_FAMS.forEach(function (f) {
      var vid = f.def;
      tick(qs('[data-tick="c' + vid + '"]', box), 'p' + vid, r2(BY[vid].price * (1 - shown / 100)));
    });
  }

  /* ---------- rendering: builder panel + bar ---------- */
  function renderPanel(sm) {
    qsa('[data-bsv-rail]').forEach(function (el) { el.style.width = sm.rail + '%'; });
    qsa('[data-bsv-stop]').forEach(function (el) { el.classList.toggle('is-reached', sm.count >= Number(el.getAttribute('data-bsv-stop'))); });
    qs('[data-bsv-msg]').textContent = nextMsg(sm.count);

    var lines = qs('[data-bsv-lines]');
    if (!sm.lines.length) lines.innerHTML = '<div class="bsv-empty">' + esc(M.empty) + '</div>';
    else lines.innerHTML = sm.lines.map(function (l) {
      return '<div class="bsv-line"><div class="bsv-line__img"><img src="' + esc(l.p.img) + '" alt="" width="56" height="56"></div>' +
        '<div class="bsv-line__info"><div class="bsv-line__name" title="' + esc(l.p.name) + '">' + esc(shortName(l.p.name)) + '</div><div class="bsv-line__price">' + (sm.pct > 0 ? '<s>' + fmt(l.p.price * l.qty) + '</s>' : '') + '<span class="bsv-tick" data-tick="ln' + l.id + '"></span></div>' +
        '<button type="button" class="bsv-line__remove" data-remove="' + l.id + '">' + esc(M.remove) + '</button></div>' +
        '<div class="bsv-stepper bsv-stepper--sm"><button type="button" data-dec="' + l.id + '" aria-label="Fjern en">−</button><span class="bsv-stepper__qty">' + l.qty + '</span><button type="button" data-inc="' + l.id + '" aria-label="Tilføj en">+</button></div></div>';
    }).join('');
    sm.lines.forEach(function (l) { tick(qs('[data-tick="ln' + l.id + '"]', lines), 'ln' + l.id, l.unit * l.qty); });

    qs('.bsv-totals').hidden = sm.count === 0;
    qs('[data-bsv-normal]').textContent = fmt(sm.normal);
    qsa('[data-bsv-total]').forEach(function (el, i) { tick(el, 'total' + i, sm.total); });
    var saveRow = qs('[data-bsv-save-row]'); saveRow.hidden = sm.pct === 0;
    qs('[data-bsv-save]').textContent = fmt(sm.saving) + ' (' + sm.pct + ' %)';

    qsa('[data-bsv-addall]').forEach(function (btn) {
      var isBar = btn.classList.contains('bsv-bar__btn');
      btn.disabled = !sm.ok || state.busy;
      btn.textContent = state.busy ? M.adding : (sm.ok ? (isBar ? M.addAllShort : M.addAll) : M.min);
      btn.classList.toggle('is-loading', state.busy);
    });

    var label = sm.count === 0 ? M.barEmpty : sm.ok ? M.barPrefix + ' ' + sm.count + ' ' + M.many + ' · ' + sm.pct + ' %' : M.barPrefix + ' ' + sm.count + ' ' + (sm.count === 1 ? M.one : M.many);
    qs('[data-bsv-barlabel]').textContent = label;
    var nb = qs('[data-bsv-normal-bar]'); nb.hidden = sm.pct === 0; nb.textContent = fmt(sm.normal);
    var sb = qs('[data-bsv-save-bar]'); if (sb) { sb.hidden = sm.pct === 0; sb.textContent = M.save + ' ' + fmt(sm.saving); }
  }

  function renderAll() {
    var sm = summary(state.qty);
    renderTiers(sm.pct);
    renderPop();
    renderGrid();
    renderPanel(sm);
    renderQuick(); renderSets();
    if (typeof qvRender === 'function') qvRender();
  }

  /* ---------- sheet (mobile) ---------- */
  var panel = qs('[data-bsv-panel]'), overlay = qs('[data-bsv-overlay]');
  function openSheet() {
    if (window.matchMedia('(min-width: 1024px)').matches) return;
    state.open = true; overlay.hidden = false;
    requestAnimationFrame(function () { overlay.classList.add('is-open'); panel.classList.add('is-open'); });
    panel.setAttribute('aria-modal', 'true'); document.body.style.overflow = 'hidden';
    var close = qs('[data-bsv-close]'); if (close) close.focus();
  }
  function closeSheet() {
    if (!state.open) return;
    state.open = false; overlay.classList.remove('is-open'); panel.classList.remove('is-open');
    panel.setAttribute('aria-modal', 'false'); document.body.style.overflow = '';
    setTimeout(function () { if (!state.open) overlay.hidden = true; }, 320);
  }

  /* ---------- cart ---------- */
  function fetchCart() { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
  var MARK = '_bland_selv';
  function isPackLine(it) { return BY[it.variant_id] && it.properties && it.properties[MARK] === '1'; }
  function mirrorFromCart(cart) {
    var q = {};
    (cart.items || []).forEach(function (it) { if (isPackLine(it)) q[it.variant_id] = (q[it.variant_id] || 0) + it.quantity; });
    state.qty = q; state.sel = selFor(q, state.sel);
    Object.keys(q).forEach(function (id) { lastTick['ln' + id] = null; });
    renderAll();
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, credentials: 'same-origin', body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error(url + ' ' + r.status); return r.json(); });
  }
  function addAll() {
    var sm = summary(state.qty); if (!sm.ok || state.busy) return;
    state.busy = true; renderPanel(sm);
    fetchCart().then(function (cart) {
      var lines = {}; (cart.items || []).forEach(function (it) { if (isPackLine(it)) lines[it.variant_id] = it; });
      var adds = [], changes = [];
      Object.keys(state.qty).forEach(function (id) {
        var props = {}; props[MARK] = '1';
        if (!lines[id]) adds.push({ id: Number(id), quantity: state.qty[id], properties: props });
        else if (lines[id].quantity !== state.qty[id]) changes.push({ id: lines[id].key, quantity: state.qty[id] });
      });
      Object.keys(lines).forEach(function (id) { if (!state.qty[id]) changes.push({ id: lines[id].key, quantity: 0 }); });
      var chain = Promise.resolve();
      changes.forEach(function (c) { chain = chain.then(function () { return post('/cart/change.js', c); }); });
      if (adds.length) chain = chain.then(function () { return post('/cart/add.js', { items: adds }); });
      return chain;
    }).then(function () {
      state.busy = false; closeSheet(); renderAll();
      track('bsv_add_all', { count: sm.count, pct: sm.pct, total: sm.total });
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
    }).catch(function (err) {
      console.error('[bsv] add to cart failed', err);
      state.busy = false; renderAll();
      alertError();
    });
  }
  function alertError() {
    var msg = qs('[data-bsv-msg]'); var prev = msg.textContent; msg.textContent = M.error; setTimeout(function () { msg.textContent = nextMsg(count(state.qty)); }, 3000); void prev;
  }
  function track(name, data) {
    try { if (window.dataLayer) window.dataLayer.push(Object.assign({ event: name }, data)); } catch (e) { /* analytics optional */ }
  }

  /* ---------- events ---------- */
  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-inc],[data-dec],[data-remove],[data-size],[data-filter],[data-set],[data-bsv-open],[data-bsv-close],[data-bsv-addall],[data-bsv-overlay],[data-qv]');
    if (!t) return;
    if (t.hasAttribute('data-qv')) { e.preventDefault(); return openQuickView(Number(t.getAttribute('data-qv'))); }
    if (t.hasAttribute('data-inc')) return change(Number(t.getAttribute('data-inc')), 1);
    if (t.hasAttribute('data-dec')) return change(Number(t.getAttribute('data-dec')), -1);
    if (t.hasAttribute('data-remove')) return remove(Number(t.getAttribute('data-remove')));
    if (t.hasAttribute('data-size')) { state.sel = Object.assign({}, state.sel); state.sel[t.getAttribute('data-fid')] = Number(t.getAttribute('data-size')); return renderGrid(); }
    if (t.hasAttribute('data-filter')) { state.filter = t.getAttribute('data-filter'); renderChips(); return renderGrid(); }
    if (t.hasAttribute('data-set')) return loadSet(SETS[Number(t.getAttribute('data-set'))]);
    if (t.hasAttribute('data-bsv-open')) return openSheet();
    if (t.hasAttribute('data-bsv-close') || t.hasAttribute('data-bsv-overlay')) return closeSheet();
    if (t.hasAttribute('data-bsv-addall')) return addAll();
  });
  var sortSel = qs('[data-bsv-sort]');
  if (sortSel) sortSel.addEventListener('change', function () { state.sort = sortSel.value; renderGrid(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && state.open) closeSheet(); });
  window.matchMedia('(min-width: 1024px)').addEventListener('change', function (mq) { if (mq.matches) closeSheet(); });

  // Keep the builder in sync when the theme's cart drawer changes quantities.
  var syncTimer = null;
  function scheduleSync() { if (state.busy) return; clearTimeout(syncTimer); syncTimer = setTimeout(function () { fetchCart().then(mirrorFromCart).catch(function () {}); }, 400); }
  document.addEventListener('cart:refresh', scheduleSync);
  if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.subscribe) {
    try { FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, scheduleSync); } catch (e) { /* optional */ }
  }

  /* ---------- quick view ---------- */
  var qv = qs('[data-bsv-qv]');
  var qvCache = {};
  var qvCurrent = null;
  function qvActionsHtml(vid) {
    var p = BY[vid]; var q = state.qty[vid] || 0;
    if (!p.available) return '<div class="bsv-stepper" style="border-color:var(--bsv-line)"><span class="bsv-stepper__qty" style="grid-column:1/-1;color:var(--bsv-ink-faint)">' + esc(M.soldOut) + '</span></div>';
    return q > 0
      ? '<div class="bsv-stepper bsv-stepper--qv"><button type="button" data-dec="' + vid + '" aria-label="Fjern en">−</button><span class="bsv-stepper__qty">' + q + '</span><button type="button" data-inc="' + vid + '" aria-label="Tilføj en">+</button></div><span class="bsv-qv__inpack">' + esc(M.inPack) + '</span>'
      : '<button type="button" class="bsv-btn bsv-btn--primary bsv-qv__add" data-inc="' + vid + '">' + esc(M.add) + '</button>';
  }
  function qvRender() {
    if (!qv || qvCurrent == null) return;
    var vid = qvCurrent; var p = BY[vid]; var pct = pctFor(count(state.qty)); var shown = pct || TIERS[0][1];
    qs('[data-bsv-qv-actions]', qv).innerHTML = qvActionsHtml(vid);
    tick(qs('[data-bsv-qv-price]', qv), 'qv' + vid, r2(p.price * (1 - shown / 100)));
    qs('[data-bsv-qv-normal]', qv).textContent = fmt(p.price);
    qs('[data-bsv-qv-note]', qv).textContent = M.at + ' ' + shown + ' %';
    var sm = summary(state.qty);
    var fill = qs('[data-bsv-qv-fill]', qv); if (fill) fill.style.width = sm.rail + '%';
    qsa('[data-bsv-qv-stop]', qv).forEach(function (el) { el.classList.toggle('is-reached', sm.count >= Number(el.getAttribute('data-bsv-qv-stop'))); });
    var qm = qs('[data-bsv-qv-msg]', qv); if (qm) qm.textContent = sm.count === 0 ? nextMsg(0) : (sm.pct ? sm.count + ' ' + M.many + ' · ' + sm.pct + ' % · ' : '') + nextMsg(sm.count);
  }
  function openQuickView(vid) {
    if (!qv || !BY[vid]) return;
    var p = BY[vid]; qvCurrent = vid;
    qs('[data-bsv-qv-title]', qv).textContent = p.name;
    qs('[data-bsv-qv-reviews]', qv).innerHTML = p.reviews > 0 ? '<span class="bsv-stars" aria-hidden="true">' + stars(p.rating) + '</span>' + (p.rating > 0 ? '<b>' + String(Math.round(p.rating * 10) / 10).replace('.', ',') + '</b> · ' : '') + p.reviews + ' ' + esc(M.reviews || '') : '';
    qs('[data-bsv-qv-link]', qv).href = p.url;
    var img = qs('[data-bsv-qv-img]', qv); img.src = p.img; img.alt = p.name;
    qs('[data-bsv-qv-thumbs]', qv).innerHTML = '';
    qs('[data-bsv-qv-desc]', qv).innerHTML = '<p class="bsv-qv__loading">…</p>';
    qvRender();
    qv.hidden = false; requestAnimationFrame(function () { qv.classList.add('is-open'); }); document.body.style.overflow = 'hidden';
    qs('[data-bsv-qv-close]', qv).focus();
    track('bsv_quick_view', { handle: p.handle });
    var load = qvCache[p.handle] || (qvCache[p.handle] = fetch(p.url.split('?')[0] + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }));
    load.then(function (d) {
      if (qvCurrent !== vid) return;
      var html = String(d.description || '').replace(/<script[\s\S]*?<\/script>/gi, '').replace(/ on\w+="[^"]*"/gi, '');
      qs('[data-bsv-qv-desc]', qv).innerHTML = html;
      var imgs = (d.images || []).slice(0, 6);
      qs('[data-bsv-qv-thumbs]', qv).innerHTML = imgs.length > 1 ? imgs.map(function (u, i) { var src = u.replace(/(\.[a-z]+)(\?|$)/i, '_300x$1$2'); return '<button type="button" class="bsv-qv__thumb' + (i === 0 ? ' is-active' : '') + '" data-qv-thumb="' + esc(u) + '" aria-label="Billede ' + (i + 1) + '"><img src="' + esc(src) + '" alt="" loading="lazy" width="64" height="64"></button>'; }).join('') : '';
    }).catch(function () { qs('[data-bsv-qv-desc]', qv).innerHTML = ''; });
  }
  function closeQuickView() {
    if (!qv || qv.hidden) return;
    qv.classList.remove('is-open'); qvCurrent = null; document.body.style.overflow = state.open ? 'hidden' : '';
    setTimeout(function () { if (qvCurrent == null) qv.hidden = true; }, 250);
  }
  if (qv) {
    qv.addEventListener('click', function (e) {
      if (e.target.closest('[data-bsv-qv-close]')) return closeQuickView();
      var th = e.target.closest('[data-qv-thumb]'); if (th) { qs('[data-bsv-qv-img]', qv).src = th.getAttribute('data-qv-thumb').replace(/(\.[a-z]+)(\?|$)/i, '_900x$1$2'); qsa('.bsv-qv__thumb', qv).forEach(function (b) { b.classList.toggle('is-active', b === th); }); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeQuickView(); });
  }

  /* ---------- video slider ---------- */
  (function () {
    var track = qs('[data-bsv-vtrack]'); if (!track) return;
    var vids = qsa('video', track);
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { var v = en.target; if (en.isIntersecting && en.intersectionRatio > .6) { v.play().catch(function () {}); } else { v.pause(); } });
      }, { threshold: [0, .6, 1] });
      vids.forEach(function (v) { v.muted = true; v.loop = true; v.playsInline = true; io.observe(v); });
    }
    function step(dir) { var card = track.querySelector('.bsv-video'); var w = card ? card.getBoundingClientRect().width + 16 : 300; track.scrollBy({ left: dir * w, behavior: 'smooth' }); }
    var prev = qs('[data-bsv-vprev]'), next = qs('[data-bsv-vnext]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    track.addEventListener('click', function (e) {
      var b = e.target.closest('[data-bsv-sound]'); if (!b) return;
      var v = b.parentNode.querySelector('video'); if (!v) return;
      vids.forEach(function (o) { if (o !== v) { o.muted = true; o.parentNode.classList.remove('is-sound'); } });
      v.muted = !v.muted; v.parentNode.classList.toggle('is-sound', !v.muted); if (!v.muted) v.play().catch(function () {});
    });
  })();

  /* ---------- bestsellers arrows (desktop; the row swipes on mobile) ---------- */
  (function () {
    var track = qs('[data-bsv-pop]'), nav = qs('[data-bsv-popnav]');
    if (!track || !nav) return;
    var prev = qs('[data-bsv-pprev]', nav), next = qs('[data-bsv-pnext]', nav);
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      nav.hidden = max <= 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
    }
    function step(dir) { var card = track.querySelector('.bsv-card'); var w = card ? card.getBoundingClientRect().width + 16 : 280; track.scrollBy({ left: dir * w, behavior: REDUCED ? 'auto' : 'smooth' }); }
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    setTimeout(update, 0);
  })();

  /* ---------- hide floating third-party widgets on this page (inline !important beats CSS) ---------- */
  (function () {
    var list = String(CFG.hideSelectors || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
    if (!list.length || !qs('style') && false) return;
    var sel = list.join(',');
    function hide() { try { document.querySelectorAll(sel).forEach(function (el) { el.style.setProperty('display', 'none', 'important'); }); } catch (e) { /* bad selector */ } }
    hide();
    if ('MutationObserver' in window) new MutationObserver(hide).observe(document.body, { childList: true, subtree: false });
    [800, 2000, 4000].forEach(function (ms) { setTimeout(hide, ms); });
  })();

  /* ---------- init ---------- */
  state.sel = selFor({});
  renderChips(); renderQuick(); renderSets(); renderAll();
  fetchCart().then(mirrorFromCart).catch(function (e) { console.warn('[bsv] cart mirror failed', e); }).then(function () {
    /* Deep link from a product page: ?add=<variant id> puts that product in the pack as item 1 (once, then the param is dropped). */
    try {
      var params = new URLSearchParams(location.search); var addId = params.get('add');
      if (addId && BY[addId] && BY[addId].available && !state.qty[addId]) {
        FAMILIES.forEach(function (f) { if (f.variants.some(function (v) { return String(v.id) === String(addId); })) state.sel[f.fid] = Number(addId); });
        change(Number(addId), 1);   /* local pack state only – the cart is written on "Læg hele pakken i kurven" */
        var grid = qs('[data-bsv-grid]'); if (grid) setTimeout(function () { grid.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 300);
      }
      if (addId) { params.delete('add'); history.replaceState(null, '', location.pathname + (params.toString() ? '?' + params : '') + location.hash); }
    } catch (e) { console.warn('[bsv] deep link failed', e); }
  });
})();
